import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AccountsContextService } from 'src/app/accounts/account-context.service';
import { IPatron, PatronService } from './patron.service';

@Component({
  selector: 'app-patron',
  templateUrl: './patron.component.html',
  styleUrls: ['./patron.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PatronComponent implements OnInit, OnDestroy {
  public patron$: BehaviorSubject<IPatron | null> = new BehaviorSubject<IPatron | null>(null);

  private destroyed$: Subject<void> = new Subject();

  constructor(private contextService: AccountsContextService, private patronService: PatronService) {
  }

  public ngOnInit(): void {
    this.contextService.account$
      .pipe(
        takeUntil(this.destroyed$),
        filter(acc => !!acc.id),
      )
      .subscribe(({ id }) => {
        this.patron$.next(null);

        this.patronService.getPatronByAccount(id)
          .subscribe(
            data => {
              this.patron$.next(data?.data);
              // TODO: Check another way to resize aside footer dynamically
              window.dispatchEvent(new Event('resize'));
            },
            () => {},
          );
      });
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
